const carousels = async function () {
    const quoteCarousel = [...document.querySelectorAll(".quote-carousel")];
    const infinityYCarousel = [...document.querySelectorAll(".infinity-y-carousel")];
    const infinityXCarousel = [...document.querySelectorAll(".infinity-x-carousel")];
    const postsCarousel = [...document.querySelectorAll(".posts-carousel")];
    const bannerSwiper = [...document.querySelectorAll(".banner-swiper")];
    const heroAnimation = document.querySelector(".hero-animation");
    const carouselContent = [...document.querySelectorAll(".carousel-content")];
    const twoColumnGalleryPopup = [...document.querySelectorAll(".two-column-gallery-popup ")];

    if (quoteCarousel || infinityYCarousel || postsCarousel || bannerSwiper || heroAnimation || carouselContent || twoColumnGalleryPopup) {
        const Swiper = await (await import("swiper/bundle")).default;
        
        if ( heroAnimation ) {
            const currentSlideText = heroAnimation.querySelector(".hero-animation__current-slide");
            const progressBar = heroAnimation.querySelector(".hero-animation__progress");
            const buttonPrev = heroAnimation.querySelector(".hero-animation__button-prev");
            const buttonNext = heroAnimation.querySelector(".hero-animation__button-next");

            // LottiePlayer 
            let LottiePlayer = await import("@lottiefiles/lottie-player");
            
            const animationSpeed = 1000;
            const textsCarousel = new Swiper(heroAnimation.querySelector(".slides-text"), {
                loop: true,
                autoplay: {
                    delay: 8000,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                },
                navigation: {
                    prevEl: buttonPrev,
                    nextEl: buttonNext,
                },
                slidesPerView: 1,
                speed: animationSpeed,
                autoHeight: true,
                watchSlidesProgress: true,
                effect: "creative",
                creativeEffect: {
                    limitProgress: 1,
                    perspective: false,
                    prev: {
                        translate: ["-50px", 0, 0],
                        opacity: 0,
                    },
                    next: {
                        translate: ["50px", 0, 0],
                        opacity: 0,
                    },
                },
                breakpoints: {
                    1024: {
                        autoHeight: false,
                    }
                },
                on: {
                    slideChange: (swiper) => {
                        const current = swiper.realIndex + 1;
                        const slidesCount = swiper.$el[0].querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;

                        currentSlideText.textContent = current < 10 ? "0" + current : current;
                        progressBar.style.width =  `${(current / slidesCount) * 100}%`;
                    },
                },
            });
            
            const slidesAnimation = new Swiper(".slides-animation", {
                loop: true,
                slidesPerView: 1,
                speed: animationSpeed,
                effect: "creative",
                creativeEffect: {
                    // shadowPerProgress: true,
                    // limitProgress: 1,
                    // perspective: false,
                    prev: {
                        translate: ["-50px", 0, 0],
                        opacity: 0,
                    },
                    next: {
                        translate: ["50px", 0, 0],
                        opacity: 0,
                    },
                },
                on: {
                    init: (swiper) => {
                       const slides = swiper.$el[0].querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate) lottie-player");
                       setTimeout(() => {
                           slides.forEach((slide, index)=> {
                               try {
                                   slide.load(slide.dataset.src);
                                   
                                   if ( index === 0 ) slide.play(); 
                               } catch (e) {}
                           })
                       }, 10)
                    },
                    slideChange: (swiper) => {
                        const currentSlide = swiper.slides[swiper.activeIndex];
                        const player = currentSlide.querySelector("lottie-player");
                        
                        try {
                            // play current animation
                            player.play();
                            
                            setTimeout(() => {
                                // reset prev and next animation
                                swiper.slides[swiper.activeIndex - 1]?.querySelector("lottie-player").stop();
                                swiper.slides[swiper.activeIndex + 1]?.querySelector("lottie-player").stop();
                            }, animationSpeed);
                        } catch (e) {}
                    },
                }
            });

            textsCarousel.controller.control = slidesAnimation;
            slidesAnimation.controller.control = textsCarousel;

            function stopAutoPlay() {
                if ( window.innerWidth >= 1024 ) {
                    textsCarousel.autoplay.start();
                }
                else {
                    textsCarousel.autoplay.stop();
                }
            }

            window.addEventListener("resize", stopAutoPlay);
            
            stopAutoPlay();
        }

        if (quoteCarousel) {
            quoteCarousel.forEach(section => {
                const size = section.querySelector(".swiper").dataset.slideSize;
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false,  
                    },
                    centeredSlides: true,
                    slideToClickedSlide: true,
                    watchSlidesProgress: true,
                    simulateTouch: true,
                    slidesPerView: 1,
                    spaceBetween: 21,
                    speed: 800,
                    navigation: {
                        prevEl: section.querySelector(".quote-carousel__button--prev"),
                        nextEl: section.querySelector(".quote-carousel__button--next"),
                    },
                    breakpoints: {
                        '768': {
                            slidesPerView: 1.6,
                        },
                        '1024': {
                            slidesPerView: 1.6,
                            spaceBetween: 32,
                        },
                        '1280': {
                            slidesPerView: 2,
                            shortSwipes: false,
                        },
                        '1440': {
                            slidesPerView: 2.3,
                        },
                        '1600': {
                            slidesPerView: size === "big" ? 2.6 : 3,
                        },
                        '1920': {
                            slidesPerView: 3,
                        }
                    },
                })
                
                if ( section.querySelector(".swiper.no-autoplay")) {
                    carousel.autoplay.stop();
                }
            })
        }

        if (infinityYCarousel) {
            infinityYCarousel.forEach(section => {
                let small = section.scrollHeight;
                const carousel = new Swiper(section, {
                    direction: "vertical",
                    loop: true,
                    freeMode: true,
                    freeModeMomentum: false,
                    autoplay: {
                        enable: true,
                        delay: 500,
                        disableOnInteraction: false,
                    },
                    centeredSlides: false,
                    autoHeight: true,
                    watchSlidesProgress: true,
                    allowTouchMove: false,
                    simulateTouch: false,
                    slidesPerView: "auto",
                    spaceBetween: 30,
                    speed: 2500,
                    breakpoints: {
                        1024: {
                            centeredSlides: true,  
                        },
                        1440: {
                            speed: 1500,
                            centeredSlides: true,
                        },
                    }
                })
            })
        }

        if (infinityXCarousel) {
            infinityXCarousel.forEach(section => {
                const slidesCount = section.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)").length;
                
                const carousel = new Swiper(section, {
                    loop: true,
                    lazy: true,
                    freeMode: true,
                    freeModeMomentum: false,
                    // autoHeight: true,
                    autoplay: {
                        delay: 0,
                        pauseOnMouseEnter: false,
                        disableOnInteraction: false,
                    },
                    watchSlidesProgress: true,
                    allowTouchMove: false,
                    simulateTouch: false,
                    slidesPerView: 2,
                    spaceBetween: 80,
                    speed: 7000,
                    on: {
                        init: (swiper) => stopAutoPlay(swiper),
                        slideChange: function (swiper) {
                            swiper.slides.forEach(slide => {
                                if (section.getBoundingClientRect().right >= slide.getBoundingClientRect().right) {
                                    slide.classList.add("show-in");
                                }
                            })
                        }
                    },
                    breakpoints: {
                        640: {
                            slidesPerView: 3,
                            spaceBetween: 60,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: slidesCount <= 10 ? 5 : 6,
                            spaceBetween: 60,
                        }
                    }
                })
                
                // stop autoplay when there is a desktop and the slides are less than 6
                function stopAutoPlay(swiper = null) {
                    const el = swiper.type !== 'resize' ? swiper : carousel;
                    
                    if ( window.innerWidth > 1024 && slidesCount <= 10 ) {
                        el.autoplay.stop();
                    }
                    else {
                        el.autoplay.start();
                    }
                }
                
                window.addEventListener("resize", stopAutoPlay);
            })
        }

        if (postsCarousel) {
            postsCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    loopAdditionalSlides: 3,
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false,
                    },
                    watchSlidesProgress: true,
                    shortSwipes: false,
                    slidesPerView: 1,
                    spaceBetween: 36,
                    speed: 400,
                    navigation: {
                        prevEl: section.querySelector(".posts-carousel__button--prev"),
                        nextEl: section.querySelector(".posts-carousel__button--next"),
                    },
                    breakpoints: {
                        '768': {
                            slidesPerView: 1.6,
                        },
                        '1440': {
                            slidesPerView: 3,
                        },
                    },
                })
            })
        }

        if (bannerSwiper) {
            bannerSwiper.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 1,
                    spaceBetween: 20,
                    speed: 800,
                    autoHeight: true,
                    navigation: {
                        prevEl: section.querySelector(".banner-swiper__button--prev"),
                        nextEl: section.querySelector(".banner-swiper__button--next"),
                    },
                })
            })
        }

        if (carouselContent) {
            carouselContent.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 50,
                    loopAdditionalSlides: 3,
                    speed: 800,
                    shortSwipes: false,
                    navigation: {
                        prevEl: section.querySelector(".carousel-content-button--prev"),
                        nextEl: section.querySelector(".carousel-content-button--next"),
                    },
                })
            })
        }

        if (twoColumnGalleryPopup) {
            twoColumnGalleryPopup.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    loopAdditionalSlides: 3,
                    speed: 600,
                    navigation: {
                        prevEl: section.querySelector(".two-column-gallery-popup--button-prev"),
                        nextEl: section.querySelector(".two-column-gallery-popup--button-next"),
                    },
                });

                const popup = section.querySelector(".popup");
                const popupContent = popup.querySelector(".popup__content");
                const buttons = [...section.querySelectorAll(".popup-button")];

                function openPopup(index) {
                    popup.classList.remove("invisible", "opacity-0");
                    carousel.slideToLoop(index, 0); // `slideToLoop` ensures correct slide in looped swipers
                    document.body.classList.add("overflow-hidden");
                    setTimeout(() => {
                        document.addEventListener("click", closeOutSide);
                    });
                }

                function closePopup() {
                    popup.classList.add("invisible", "opacity-0");
                    document.body.classList.remove("overflow-hidden");
                    document.removeEventListener("click", closeOutSide);
                }

                function closeOutSide(e) {
                    if (!popupContent.contains(e.target)) closePopup();
                }

                buttons.forEach(item => {
                    const index = parseInt(item.dataset.index, 10);
                    if (!isNaN(index)) {
                        item.addEventListener("click", () => {
                            openPopup(index);
                        });
                    }
                });
            });
        }
    }
}

export const init = carousels;